import React from 'react';
import { buildApiUrl } from '../config/api';

export function statisticsPath({ from, to, trainer }) {
  const query = new URLSearchParams(from && to ? { from, to } : { scope: 'all' });
  if (trainer) query.set('trainer', trainer);
  return `/api/requests/statistics?${query}`;
}

export default function useRequestStatistics({ active, valid, from, to, trainer, refreshKey = 0 }) {
  const path = statisticsPath({ from, to, trainer });
  const [state, setState] = React.useState({ key: '', data: null, loading: false, error: '', updatedAt: null });
  const cache = React.useRef(new Map());
  React.useEffect(() => {
    if (!active || !valid) return;
    const controller = new AbortController();
    const previous = cache.current.get(path);
    setState({ key: path, data: previous?.data || null, loading: true, error: '', updatedAt: previous?.updatedAt || null });
    (async () => {
      try {
        const response = await fetch(buildApiUrl(path), { signal: controller.signal });
        if (!response.ok) throw new Error('Не вдалося завантажити статистику. Натисни оновлення, щоб спробувати ще раз.');
        const data = await response.json();
        if (!data?.totals || !Array.isArray(data.clients) || !Array.isArray(data.trainers)) throw new Error('Некоректна відповідь статистики.');
        if (controller.signal.aborted) return;
        const result = { data, updatedAt: new Date() };
        cache.current.set(path, result);
        setState({ key: path, ...result, loading: false, error: '' });
      } catch (error) {
        if (!controller.signal.aborted) setState(prev => ({ ...prev, loading: false, error: error.message }));
      }
    })();
    return () => controller.abort();
  }, [active, valid, path, refreshKey]);
  return state.key === path ? state : { data: null, loading: !!active && !!valid, error: '', updatedAt: null };
}
